import config from "../config";

export const setToken = ({token, firstName, lastName}) => {
    localStorage.setItem("token", token);
    localStorage.setItem("firstName", firstName);
    localStorage.setItem("lastName", lastName);
}

export const getToken = () => localStorage.getItem("token")
export const getFirstName = () => localStorage.getItem("firstName")
export const getLastName = () => localStorage.getItem("lastName")

export const clearToken = () => localStorage.removeItem("token")



export const simulateDelay = async () => {
    return new Promise(resolve => setTimeout(resolve, process.env.REACT_APP_SIMULATED_DELAY || 0));
}

export const fetchHelper = async ({
    method,
    url,
    reqBody,
    contentType = "application/json",
    urlPrefix = config.apiUrl
}) => {

    // Prepare request
    const myHeaders = new Headers();
    myHeaders.append("Authorization",  getToken());
    if (contentType) myHeaders.append("Content-Type", contentType);
    const requestObject = {
        method,
        headers: myHeaders
    }
    if (reqBody) requestObject.body = JSON.stringify(reqBody);

    // Await and handle response
    await simulateDelay(500)
    const fullUrl = `${urlPrefix}${url}`;
    const response = await fetch(fullUrl, requestObject);
    if (response?.status < 400 ) {
        return response.json();
    } else if (response?.status == 401) {
        return window.location.replace("/");
    } else {
        alert("An error occurred.")
    }
}